import React, { useState, useEffect } from 'react'
import SubHeader from '../../../../../../component/common/layout/SubHeader'
import Card from '../../../../../../core/Card';
import style from "../../../../../style.module.css";
import SearchInput from "../../../../../../core/Inputs/SearchInput";
import Svg from '../../../../../../component/common/Svg';
import Slider from '../../../../../../core/Slider';
import { Link } from 'react-router-dom';
import SurveyListSidebar from '../../../../../../component/common/layout/SurveyListSidebar';
import SurveyListHeader from '../../../../../../component/common/layout/SurveyListHeader';
import LanguageSubHeader from '../../../../../../component/common/layout/LanguageSubHeader';
import Languages from '../../../../../../component/common/language/Languages';
import { useTranslation } from 'react-i18next';

export default function Index() {
    const { t, i18n } = useTranslation();
    const canEditSurveyDesign = window.modulePermissions.M12.edit == 1;
    const [styling, setstyling] = useState({
        status: false,
        from: "",
        style: ""
    });
    const [survey_id, setSurveyId] = useState('');

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper bg-white'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex bg-white">
                    <SurveyListSidebar />
                    <div className="flex-grow-1">
                        <LanguageSubHeader />
                        <div className="page-content-wrap">

                            <div className="page-heading">
                                {/* breadcrumbs here */}
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/survey/list">{t('survey.title')}</Link>
                                        </li>
                                        <li className="breadcrumb-item"><a href="#">Survey Name</a></li>
                                        <li className="breadcrumb-item active" aria-current="page"><strong>Default Language</strong></li>
                                    </ol>
                                </nav>
                                {/* breadcrumbs ends here */}
                                <h1>Default language</h1>
                            </div>
                            <div className="language-page-wrapper">
                                <div className="language-list-wrapper">
                                    <div className="form-group mb-lg-5">
                                        <div className="label-heading d-flex justify-content-between">
                                            <label>Languages</label>
                                            {/* <a className='text-primary' data-bs-toggle="modal" data-bs-target="#languageListModal" aria-haspopup="true" aria-expanded="false">Add new language</a> */}
                                        </div>
                                        <div className="language-dropdown">
                                            <Languages isDisabled={!canEditSurveyDesign} />
                                        </div>
                                        {/* <div className="language-list">
                                            <a className='language-add-wrap' data-bs-toggle="modal" data-bs-target="#languageListModal" aria-haspopup="true" aria-expanded="false"></a>
                                            <div className="chstom-chips-list d-flex">
                                                <div className="chip d-flex">
                                                    <div className="text align-items-center">English</div>
                                                    <button className='remove'>
                                                        <Svg name="remove-icn" />
                                                    </button>
                                                </div>
                                                <div className="chip d-flex">
                                                    <div className="text align-items-center">Spanish</div>
                                                    <button className='remove'>
                                                        <Svg name="remove-icn" />
                                                    </button>
                                                </div>
                                                <div className="chip d-flex">
                                                    <div className="text align-items-center">German</div>
                                                    <button className='remove'>
                                                        <Svg name="remove-icn" />
                                                    </button>
                                                </div>
                                                <div className="chip d-flex">
                                                    <div className="text align-items-center">Russian</div>
                                                    <button className='remove'>
                                                        <Svg name="remove-icn" />
                                                    </button>
                                                </div>
                                                <div className="chip d-flex">
                                                    <div className="text align-items-center">Hindi</div>
                                                    <button className='remove'>
                                                        <Svg name="remove-icn" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className="form-group mb-lg-5 language-select">
                                        <label>Global Default language</label>
                                        <div className="dropdown table-dropdown ques-options">
                                            <button className="btn dropdown-tgl" type="button" id="quesoptions" data-bs-toggle={canEditSurveyDesign ? "dropdown" : undefined}
                                                aria-haspopup="true" aria-expanded="false" disabled={!canEditSurveyDesign}>
                                                English
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="quesoptions">
                                                <a className="dropdown-item"> French </a>
                                                <a className="dropdown-item"> German </a>
                                                <a className="dropdown-item"> English </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="customvar-modal modal custom-modal fade languages-modal" id="languageListModal" tabIndex={-1} aria-labelledby="languageListModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"language-wrapper" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                        <div className="edit-field-wrap mb-4">
                                            <div className="d-flex justify-content-between search-wrap align-items-center">
                                                <div className="search-input-wrap flex-grow-1">
                                                    < SearchInput
                                                        type='def'
                                                        view='outlined'
                                                        color='primary'
                                                        placeholder='Search language'
                                                        fill={true}
                                                        disabled={!canEditSurveyDesign}
                                                    />
                                                </div>
                                                <div className="google-language">
                                                    <div className="d-flex align-items-center">
                                                        <div className="icon">
                                                            <Svg name="google-language" />

                                                        </div>
                                                        <div className="flex-grow-1 ps-2">
                                                            <p className='mb-0'>All added language will be Google translated</p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="language-wrapper-list">
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck1" disabled={!canEditSurveyDesign} />
                                                        <label className="form-check-label" htmlFor="languageCheck1">
                                                            Albanian
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck2" disabled={!canEditSurveyDesign} />
                                                        <label className="form-check-label" htmlFor="languageCheck2">
                                                            Amharic
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck3" disabled={!canEditSurveyDesign} />
                                                        <label className="form-check-label" htmlFor="languageCheck3">
                                                            Arabic
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck4" disabled={!canEditSurveyDesign} />
                                                        <label className="form-check-label" htmlFor="languageCheck4">
                                                            Armenian
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck5" disabled={!canEditSurveyDesign} />
                                                        <label className="form-check-label" htmlFor="languageCheck5">
                                                            Azerbaijani
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck6" disabled={!canEditSurveyDesign} />
                                                        <label className="form-check-label" htmlFor="languageCheck6">
                                                            Basque
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck7" disabled={!canEditSurveyDesign} />
                                                        <label className="form-check-label" htmlFor="languageCheck7">
                                                            Bengali
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="checkbox-wrapper">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" name="languageCheck" id="languageCheck8" disabled={!canEditSurveyDesign} />
                                                        <label className="form-check-label" htmlFor="languageCheck8">
                                                            Bosnian
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="button-wrap d-flex justify-content-end">
                                            <button type="button" className="btn btn-primary" disabled={!canEditSurveyDesign}>Proceed</button>
                                            <button type="button" className="btn btn-bordered ms-3" data-bs-dismiss="modal">Cancel</button>
                                        </div>
                                    </Card>
                                </div >

                            </div >
                        </div>
                    </div>
                </div>
            </div>

            <div className="customvar-modal modal custom-modal fade deleteModal" id="languageDeleteModal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0" + " " + style.card} >

                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>Remove this Language?</h3>
                                            </div>
                                            <div className="warning-message">
                                                <div className="title d-flex align-items-center">
                                                    <svg width={40} height={42} viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M20 2L37.3205 32H2.67949L20 2Z" stroke="#F05454" strokeWidth={3} strokeLinejoin="round" />
                                                        <path d="M20 13.5385V22" stroke="#F05454" strokeWidth={3} />
                                                        <circle cx="19.9994" cy="25.8461" r={1} fill="black" stroke="#F05454" strokeWidth="1.07692" />
                                                    </svg>
                                                    <h4>Warning</h4>
                                                </div>
                                                <p>All the data related to this language will be deleted </p>
                                            </div>

                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered color-delete" data-bs-dismiss="modal">Cancel</button>
                                                <button type="button" className="btn btn-delete ms-3">Delete</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div >

                            </div >
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
